import { createRouter, createWebHistory } from 'vue-router';
import { useIdentityStore } from '@/stores/useIdentityStore';
import Home from '@/views/home/home.vue';
import SignIn from '@/views/identity/sign.in.vue';
import news from '@/views/page/news.vue';
import apply from '@/views/page/apply.vue'; 
import resourcecenter from '@/views/page/resourcecenter.vue'; 
import contactus from '@/views/page/contactus.vue'; 

import newsview from '@/views/page/newsview.vue';
import DynamicHtmlPage from '../components/DynamicHtmlPage.vue';
import index from '@/views/page/default.vue'; 
import newsCategory from '@/views/home/newsCategory.vue'; 
import resourceCategory from '@/views/home/resource.category.vue'; 
import newContent from '@/views/home/news.list.vue';
import resource from '@/views/home/resource.center.vue'; //
import clue from '@/views/home/clue.vue';

const routes = [
  {
    path: '/',
    redirect: { name: 'index' }
  },
  {
    path: '/index',
    name: 'index',
    meta: { allowAnonymous: true }, 
    component: index,
  }, 
  {
    path: '/home',
    name: 'Home',
    meta: { allowAnonymous: false ,title:'后台管理'},
    component: Home,
  },
  {
    path: '/newContent',
    name: 'newContent',
    meta: { allowAnonymous: false,title:'新闻管理' },
    component: newContent,
  },
   {
    path: '/newsCategory',
    name: 'newsCategory',
    meta: { allowAnonymous: false,title:'新闻分类管理' },
    component: newsCategory,
  },
  
   {
    path: '/resource',
    name: 'resource',
    meta: { allowAnonymous: false,title:'资源中心管理' },
    component: resource,
  },
    {
    path: '/resourceCategory',
    name: 'resourceCategory',
    meta: { allowAnonymous: false,title:'视频中心分类管理' },
    component: resourceCategory,
  },
  {
    path: '/news',
    name: 'news',
    meta: { allowAnonymous: true },
    component: news,

  },
  {
    //path: '/newsview/:nid',
    path: '/newsview',
    name: 'newsview',
    meta: { allowAnonymous: true },
    component: newsview,

  }, 
  // {
  //   path: '/newsview/:id([^/]+).html', // 匹配 /article/123.html
  //   name: 'newsview',
  //    meta: { 
  //     allowAnonymous: true
  //     },
  //   component: newsview,
  // },
   {
    path: '/resourcecenter',
    name: 'resourcecenter',
    meta: { 
      allowAnonymous: true , 
    },
    component: resourcecenter,

  },  {
    path: '/contactus',
    name: 'contactus',
    meta: { allowAnonymous: true },
    component: contactus,

  }, 
  {
    path: '/apply',
    name: 'apply',
    meta: { allowAnonymous: true },
    component: apply,

  }, 
  //  {
  //   path: '/resourceCenter',
  //   name: 'resourceCenter',
  //   meta: { allowAnonymous: false,title:'资源中心管理' },
  //   component: resourcecenter,
  // },
 {
    path: '/clue',
    name: 'clue',
    meta: { allowAnonymous: false,title:'线索管理' },
    component: clue,
  },
  
  {
    path: '/signin',
    name: 'Signin',
    meta: { allowAnonymous: true },
    component: SignIn,
  }, 
   
   // 添加通配符路由匹配
  {
    path: '/:pathMatch(.*)*', // 通配符路径，匹配所有未定义路径
    redirect: { name: 'index' } // 重定向到 index 页面
  }
  /*  
  {
    path: '/admin',
    name: 'Admin',
    meta: { allowAnonymous: false },
    component: () => import('@/views/admin/home.vue'),
    children: [   
     
      {
        path: 'params',
        name: 'SettingParams',
        meta: { allowAnonymous: false },
        component: () => import('@/views/admin/params.vue'),
      }, 
    ],
  },  */
];

// const router = createRouter({
//   history: createWebHistory(import.meta.env.BASE_URL),
//   routes,
// });
const router = new createRouter({
  history: createWebHistory(), // 可以根据需求选择不同的路由模式，这里使用历史模式
  routes
});
// router.beforeEach((to) => {
//   window.scrollTo(0, 0);
//   const store = useIdentityStore();
//   if (to.meta.allowAnonymous) {
//     return true;
//   }
//   if (!localStorage.getItem('accessToken')) {
//     return { name: 'Signin', replace: true };
//   }
 
//   return true;
// });

router.beforeEach((to) => {
  if (to.path === '/') {
    // 如果是根路径，重定向到默认页
    //next('/index');
    return {name:'index',replace:true};
  }
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.meta.allowAnonymous) {
    return true;
  }
  else if (!localStorage.getItem('accessToken')) {
    return { 
      name: 'Signin',  query: { redirect: to.fullPath }, // 在 query 中记录目标路径 
    replace: true 
  };
  }
  
});


export default router;
